export default {
  placeholder: 'Vybrať jazyk',
};
